import { EntitySearchFilterBar } from 'src/components/EntitySearch';
import { FilterDropdownItem } from 'src/components/Filters';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import {
  Feature,
  InventorySearchResult,
  ListingQueryV2,
} from 'src/WebApiController';

import { useListingSearchFilters } from './InventorySearchFilterBar.hooks';

export const InventorySearchFilterBar = (props: {
  activeSearchConfig?: InventorySearchResult;
  onSubmitFilter?: (query: ListingQueryV2) => void;
  selectedFilters?: FilterDropdownItem[];
  setSelectedFilters: (sf: FilterDropdownItem[]) => void;
}) => {
  const hasSearchViewPerformerFilterFeature = useUserHasFeature(
    Feature.SearchViewPerformerFilter
  );

  const hasUnsoldTicketsFilterFeature = useUserHasFeature(
    Feature.UnsoldTicketsFilter
  );

  const { filters } = useListingSearchFilters({
    supportMultiOperation: true,
    isHorizontalLayout: true,
    showCatalogFilters: true,
    showVenueFilter: true,
    showPerformerFilter: hasSearchViewPerformerFilterFeature,
    firstRenderOpen: props.activeSearchConfig == null,
  });

  const hasSearchViewGroupRowWithEventFeature = useUserHasFeature(
    Feature.SearchViewGroupRowWithEvent
  );
  return (
    <EntitySearchFilterBar
      {...props}
      filters={filters}
      mandatoryFiltersToShow={[
        'eventOrMappingIds',
        'eventDates',
        ...(hasUnsoldTicketsFilterFeature
          ? (['hasUnsoldTickets'] as const)
          : []),
      ]}
      filtersToPin={
        hasSearchViewGroupRowWithEventFeature
          ? ['eventOrMappingIds']
          : undefined
      }
    />
  );
};
